export default {
	name: "Português",

	"global.itemCounts": `{total, plural,
		=0 {sem conteúdo}
		other {}
	}{collections, plural,
		=0 {}
		one {uma coleção}
		other {{collections} coleções}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {uma história}
		other {{stories} histórias}
	}`,

	"cover.stories": `{itemCount, plural,
		one {história}
		other {histórias}
	}`,

	"searchbutton.placeholder": "Procurar...",

	"flow.empty": "Não há conteúdo para mostrar.",

	"forms.submitted": "Os dados inseridos foram submetidos com sucesso.",
	"forms.errored": "Houve um problema com os dados inseridos.",
	"forms.required": "Este campo é obrigatório para enviar o formulário.",
	"forms.close": "Obrigado",

	"prevnext.prev": "história anterior",
	"prevnext.next": "história seguinte",

	"navigation.back": "voltar",
	
	"share.back": "voltar",
	"share.embed": "incorporar",
	"share.share": "partilhar",
	"share.cover": "Capa",
	"share.custom": "elemento personalizado",
	"share.inline": "incorporar diretamente",
	"share.customhere": "INSERIR O SEU PRÓPRIO ELEMENTO AQUI",
	"share.scriptonce": "O script anterior deve ser incluído apenas uma vez por página",
	"share.FacebookLabel": "Partilhar no Facebook",
	"share.TwitterLabel": "Tweet",
	"share.TwitterText": "{title}",
	"share.EmbedLabel": "incorporar",

	"more.showCollection": "Mostrar todas as histórias",
	"more.showMore": "Mostrar histórias anteriores",
	"more.showMoreBack": "«",
	"more.showMoreSearch": "Mostrar mais conteúdos",
	"more.showMoreSearchBack": "«",

	"multislider.showAll": "Mostrar todas as histórias",

	"passwordScreen.passwordPlaceholder": "palavra-passe",
	"passwordScreen.usernamePlaceholder": "utilizador",
	"passwordScreen.subTitle": "é uma {type, select, story {história} collection {coleção}} protegida",
	"passwordScreen.submit": "enviar",
	"passwordScreen.error": "autorização não é possível!",

	"like.label": "gostos {likeCount, number}",
	"like.noLikeLabel": "Gosto",
};



// WEBPACK FOOTER //
// ./lib/locales/pt.js